<template>
	<div class="col-lg-4 col-sm-12">
		<div class="card">
			<div class="card-header pt-2 pb-2">
				<span>Job Info</span>
			</div>
<!--			<div v-show="accessPrivileges.includes('CREATE_JOB') && !locked" class="list-group list-group-flush">
				<div class="list-group-item pt-1 pb-1">
					<a href="#" @click.prevent="">Edit <font-awesome-icon icon="edit"></font-awesome-icon></a>
				</div>
			</div>-->
			<div class="card-body">
				<div class="row job-row">
					<div class="col-12">
						<div v-if="jobEditMode"><strong>Job Name </strong></div>
						<div v-else><strong>Job Name </strong>
							<a v-if="!locked && accessPrivileges.includes('CREATE_JOB')" href="#" @click.prevent="enterJobEditMode"><font-awesome-icon icon="edit"></font-awesome-icon></a>
						</div>
						<ValidationProvider v-click-outside="onClickOutsideJobName" v-if="jobEditMode" ref="provider"><input @blur="onSubmit" v-model="jobName"
															  class="form form-control job-field"/></ValidationProvider>
						<div v-else class="job-field">{{ record.fieldData['Job Name'] }}</div>
					</div>
          <div class="col-12">
            <div>
              <div><strong>Purchaser Reg #</strong></div>
              <div class="job-field">{{ record.fieldData['Receiving Facility Registration'] }}</div>
            </div>
          </div>
					<div class="col-6">
						<div>
							<div><strong>Supplier Reg #</strong></div>
							<div class="job-field">{{ record.fieldData['Registration Number'] }}</div>
						</div>
						<div>
							<div><strong>Status</strong></div>
							<div class="job-field">{{ record.fieldData['Registration Status'] }}</div>
						</div>
					</div>
					<div class="col-6">
						<div>
							<div><strong>Activity</strong></div>
							<div class="job-field">{{ record.fieldData['Registration::Activity'] }}</div>
						</div>
						<div>
							<div><strong>Exp Date</strong></div>
							<div class="job-field">{{ record.fieldData['Registration Expiration'] }}</div>
						</div>
					</div>
					<div class="col-6">
						<div><strong>Sister Job</strong></div>
						<div class="job-field">{{ record.fieldData['Sister Jobs'] }}</div>
					</div>
				</div>
				<hr/>
				<div class="row">
					<div class="col-12">
						<div><strong>Company ID</strong></div>
						<div class="job-field">{{ record.fieldData['Company ID'] }}</div>
					</div>
					<div class="col-12">
						<div><strong>Company Name</strong></div>
						<div class="job-field">{{ record.fieldData['Company Name'] }}</div>
					</div>
					<div class="col-6">
						<div><strong>City</strong></div>
						<div class="job-field">{{ record.fieldData['Company City'] }}</div>
					</div>
					<div class="col-6">
						<div><strong>State</strong></div>
						<div class="job-field">{{ record.fieldData['Company State'] }}</div>
					</div>
				</div>
				<hr/>
				<div class="row job-row">
					<div class="col-12">
						<div><strong>Filed</strong></div>
						<div class="job-field">{{ record.fieldData['Date Filed'] }}</div>
					</div>
					<div class="col-6">
						<div><strong>Initiated</strong></div>
						<div class="job-field">{{ record.fieldData['Date Job Initiated'] }}</div>
					</div>
					<div class="col-6">
						<div><strong>Confirmed</strong></div>
						<div class="job-field">{{ record.fieldData['Date Job Confirmed'] }}</div>
					</div>
					<div class="col-12">
						<div><strong>Client Contact</strong></div>
						<div class="job-field">{{ record.fieldData['Client Contact Person'] }}</div>
					</div>
				</div>
				<hr/>
				<div class="row job-row">
					<div class="col-12">
						<div><strong>Transporter</strong></div>
						<div class="job-field">{{ record.fieldData.Transporter }}</div>
					</div>
					<div class="col-12">
						<div><strong>Transport Facility</strong></div>
						<div class="job-field">{{ record.fieldData['Facility Transported To'] }}</div>
					</div>
					<div class="col-12">
						<div><strong>Disposal Method</strong></div>
						<div class="job-field">{{ record.fieldData['Disposal Method'] }}</div>
					</div>
					<div class="col-12">
						<div><strong>Process Utilized</strong></div>
						<div class="job-field">{{ record.fieldData['Process Utilized'] }}</div>
					</div>
				</div>
				<hr/>
				<div class="row job-row">
					<div class="col-12">
						<div><strong>Job Category</strong></div>
						<div class="job-field">{{ record.fieldData['Job Category'] }}</div>
					</div>
					<div class="col-6">
						<div><strong>Transferred</strong></div>
						<div class="job-field">{{ record.fieldData['Date Transfer'] }}</div>
					</div>
					<div class="col-6">
						<div><strong>Destroyed</strong></div>
						<div class="job-field">{{ record.fieldData['Date Destroyed'] }}</div>
					</div>
					<div class="col-6">
						<div><strong>Vault In</strong></div>
						<div class="job-field">{{ record.fieldData['Date Vault In'] }}</div>
					</div>
					<div class="col-6">
						<div><strong>Vault Out</strong></div>
						<div class="job-field">{{ record.fieldData['Date Vault Out'] }}</div>
					</div>
					<div class="col-6">
						<div><strong>Transfer Witness 1</strong></div>
						<div class="job-field">{{ record.fieldData['Job_Agent_fkAgentTransferWitness1::FullName'] }}</div>
					</div>
					<div class="col-6">
						<div><strong>Destruction Witness 1</strong></div>
						<div class="job-field">{{ record.fieldData['Job_Agent_fkAgentDestructionWitness1::FullName'] }}</div>
					</div>
					<div class="col-6">
						<div><strong>Transfer Witness 2</strong></div>
						<div class="job-field">{{ record.fieldData['Job_Agent_fkAgentTransferWitness2::FullName'] }}</div>
					</div>
					<div class="col-6">
						<div><strong>Destruction Witness 2</strong></div>
						<div class="job-field">{{ record.fieldData['Job_Agent_fkAgentDestructionWitness2::FullName'] }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BaseView from '../BaseView'
import {ValidationProvider} from 'vee-validate';
// import vClickOutside from 'v-click-outside'

export default {
	name: "JobView",
	extends: BaseView,
	components: {ValidationProvider},
	data() {
		return {
			jobEditMode: false,
			jobName: ''
		}
	},
	methods: {
		onClickOutsideJobName() {
			this.jobEditMode = false
		},
		enterJobEditMode() {
			this.jobEditMode = true
			this.jobName = this.record.fieldData['Job Name']
		},
		onSubmit() {
			let that = this
			if(this.$refs.provider.flags.dirty) {
				this.axios.patch('/3ds/api/job/' + this.recordId, {
					fieldData: {
						'Job Name': this.jobName
					}
				})
				.then(value => {
					console.log(JSON.stringify(value))
					that.record.fieldData['Job Name'] = that.jobName
				})
				.catch(reason => {
					console.error(JSON.stringify(reason))
					that.EditMode = false
					that.jobName = that.record.fieldData['Job Name']
				})
				.finally(() => {
					that.jobEditMode = false;
				})
			} else {
				this.jobEditMode = false
			}
		}
	},
}
</script>